// Plant Pad Modal Form Handler
// Handles subscription pricing and add to cart for plant-pad-modal

if (!customElements.get('plant-pad-modal-form')) {
    customElements.define(
      'plant-pad-modal-form',
      class PlantPadModalForm extends HTMLElement {
        constructor() {
          super();
          this.modalContent = null;
          this.closeModalFn = null;
          this.initialized = false;
        }
  
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          
          // Modal content is the parent we were appended to (product-modal-content div)
          this.modalContent = this.parentElement;
          if (!this.modalContent || !this.modalContent.classList.contains('product-modal-content')) {
            this.modalContent = this.closest('.product-modal-content');
          }
          if (!this.modalContent) {
            const modalOverlay = document.querySelector('.product-modal-overlay');
            if (modalOverlay) {
              this.modalContent = modalOverlay.querySelector('.product-modal-content');
            }
          }
          
          if (this.modalContent) {
            setTimeout(() => {
              this.init();
            }, 50);
          }
        }
  
        init() {
          if (!this.modalContent) return;

          // Initialize subscription checkbox
          this.initSubscriptionCheckbox();
          
          // Initialize add to cart
          this.initAddToCart();
        }
  
        updateSubscriptionPriceDisplay(checkbox) {
          const subscriptionRow = checkbox.closest('.subscription-row');
          const subscriptionPriceSpan = subscriptionRow && subscriptionRow.querySelector('.subscription-price');
          if (!subscriptionPriceSpan) return;
          const newPrice = checkbox.checked
            ? (subscriptionPriceSpan.dataset.sellingPlanPrice || subscriptionPriceSpan.textContent || '').trim()
            : (subscriptionPriceSpan.dataset.regularPrice || '').trim();
          if (!newPrice) return;

          var container = this.modalContent;
          var priceContainers = container.querySelectorAll('[id^="price-"], .price');
          if (priceContainers.length === 0) {
            var overlay = document.querySelector('.product-modal-overlay');
            if (overlay) {
              container = overlay;
              priceContainers = container.querySelectorAll('[id^="price-"], .price');
            }
          }
          priceContainers.forEach(function (priceContainer) {
            var salePrice = priceContainer.querySelector('.price__sale .price-item--sale');
            var regularPrice = priceContainer.querySelector('.price__regular .price-item--regular');
            var anyPrice = priceContainer.querySelector('.price-item--regular, .price-item--sale');
            [salePrice, regularPrice, anyPrice].filter(Boolean).forEach(function (el) {
              if (el && !el.closest('s')) {
                el.textContent = newPrice;
                el.classList.toggle('subscription-price-active', checkbox.checked);
              }
            });
          });
        }

        initSubscriptionCheckbox() {
          const subscriptionCheckbox = this.modalContent.querySelector('.subscription-checkbox-input');
          if (!subscriptionCheckbox) return;

          const productId = subscriptionCheckbox.dataset.productId;
          const sellingPlanId = subscriptionCheckbox.dataset.sellingPlanId;
          const sellingPlanInput = this.modalContent.querySelector('#selling-plan-' + productId);

          if (subscriptionCheckbox.checked && sellingPlanInput && sellingPlanId) {
            sellingPlanInput.value = sellingPlanId;
          }
          this.updateSubscriptionPriceDisplay(subscriptionCheckbox);

          subscriptionCheckbox.addEventListener('change', () => {
            if (subscriptionCheckbox.checked) {
              if (sellingPlanInput && sellingPlanId) {
                sellingPlanInput.value = sellingPlanId;
              }
            } else {
              if (sellingPlanInput) {
                sellingPlanInput.value = '';
              }
            }
            this.updateSubscriptionPriceDisplay(subscriptionCheckbox);
          });
        }
  
        initAddToCart() {
          const productForm = this.modalContent.querySelector('product-form');
          if (!productForm) return;
  
          const form = productForm.querySelector('form');
          const submitButton = productForm.querySelector('[type="submit"]');
          
          if (!form || !submitButton) return;
  
          // Remove default product-form handler by stopping propagation
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.handleAddToCart(e, form, submitButton);
          }, true); // Use capture phase to run before product-form handler
        }
  
        async handleAddToCart(e, form, submitButton) {
          e.preventDefault();
          e.stopPropagation();
  
          if (submitButton.getAttribute('aria-disabled') === 'true') return;
  
          // Get form data
          const formData = new FormData(form);
          const variantId = formData.get('id');
          const quantity = formData.get('quantity') || 1;
          const sellingPlan = formData.get('selling_plan');
  
          if (!variantId) {
            console.error('No variant ID found');
            return;
          }
  
          // Disable button
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          const loadingSpinner = submitButton.querySelector('.loading__spinner');
          if (loadingSpinner) loadingSpinner.classList.remove('hidden');
  
          try {
            // Prepare cart add request
            const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            };
            config.headers = config.headers || {};
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
  
            const cartAddData = new FormData();
            cartAddData.append('id', variantId);
            cartAddData.append('quantity', quantity);
            if (sellingPlan) {
              cartAddData.append('selling_plan', sellingPlan);
            }
  
            // Add sections for cart drawer/notification
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cart) {
              cartAddData.append('sections', cart.getSectionsToRender().map((section) => section.id));
              cartAddData.append('sections_url', window.location.pathname);
            }
  
            config.body = cartAddData;
  
            // Get cart add URL
            const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) 
              ? routes.cart_add_url 
              : '/cart/add.js';
  
            // Add to cart
            const response = await fetch(cartAddUrl, config);
            const data = await response.json();
  
            if (data.status) {
              // Handle error
              console.error('Add to cart error:', data.description);
              submitButton.removeAttribute('aria-disabled');
              submitButton.classList.remove('loading');
              if (loadingSpinner) loadingSpinner.classList.add('hidden');
              return;
            }
  
            // Update cart
            if (cart) {
              cart.renderContents(data);
            }
  
            // Update plant-pads sidebar
            this.updatePlantPadsSidebar(data);
  
            // Close modal
            this.closeModal();
  
            // Re-enable button
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('loading');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
  
          } catch (error) {
            console.error('Add to cart error:', error);
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('loading');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
          }
        }
  
        updatePlantPadsSidebar(cartData) {
          // Find the product-form in the collection section
          const collectionSection = document.querySelector('[id^="collection-"]');
          const productFormElement = collectionSection ? collectionSection.querySelector('product-form') : null;
          
          if (productFormElement && typeof productFormElement.updatePlantPadsSidebar === 'function') {
            productFormElement.updatePlantPadsSidebar(cartData);
          }
          
          // Also dispatch event for sidebar update
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cartData: cartData }
          }));
        }
  
        closeModal() {
          const modalOverlay = document.querySelector('.product-modal-overlay');
          if (!modalOverlay) return;
  
          // Use the same closeModal function that's used when clicking outside
          if (modalOverlay.closeModal && typeof modalOverlay.closeModal === 'function') {
            modalOverlay.closeModal();
          } else {
            // Fallback: trigger close button click
            const closeButton = modalOverlay.querySelector('.modal-close');
            if (closeButton) {
              closeButton.click();
            }
          }
        }
      }
    );
  }
  
  